/**
 * Emulación de usuarios en el navegador.
 *
 * Al emular, la sesión del super admin se guarda aparte (LLAVE) y la app pasa a usar el token
 * de la emulación. Al volver —con el botón de la barra, al cerrar sesión o porque la emulación
 * venció— se restaura la sesión guardada. Siempre se recarga la página: así no queda nada del
 * usuario anterior en memoria (notificaciones, menú, datos de pantallas abiertas).
 *
 * Las reglas de quién puede emular a quién están en el backend (App\Extra\Emulacion).
 */
import store from "@/store";

const LLAVE = 'LC_emulacionAdmin';
const PREFIJO_TOKEN = 'emu_';

export function esTokenDeEmulacion(token) {
    return typeof token === 'string' && token.indexOf(PREFIJO_TOKEN) === 0;
}

function irAlInicio() {
    window.location.hash = '#/';
    window.location.reload();
}

export function iniciarEmulacion(token) {
    try {
        localStorage.setItem(LLAVE, JSON.stringify(store.getters.authInfo || {}));
    } catch (e) {
        // Sin dónde guardar la sesión propia no se emula: no habría cómo volver
        return false;
    }
    store.commit('authSetInfo', {token: token});
    irAlInicio();
    return true;
}

/** Restaura la sesión del super admin. Sin sesión guardada, manda al login. */
export function volverAlAdmin() {
    let admin = null;
    try {
        admin = JSON.parse(localStorage.getItem(LLAVE) || 'null');
        localStorage.removeItem(LLAVE);
    } catch (e) {
        admin = null;
    }
    store.commit('authSetInfo', admin || {});
    if (admin && admin.token) {
        irAlInicio();
    }
    else {
        window.location.hash = '#/login';
        window.location.reload();
    }
}
